import PropTypes from 'prop-types';
import Icon from '@/components/common/iconedLinks/Icon';

import styles from './Message.module.scss';
import { URLS } from '@/constants/urls';

const Message = ({ t, editMode, textAreaLabel, textAreaPlaceholder, message, setMessage, messageMaxLength, onblur }) => (
  <div className={styles.message} data-test-id="message-container">
    {editMode ? (
      <>
        <label htmlFor="message" data-test-id="message-label">
          {t(textAreaLabel, { count: messageMaxLength - (message?.length ?? 0) })}
        </label>
        <textarea
          style={{ fontSize: '16px' }}
          id="message"
          className="form-control"
          rows="4"
          value={message ?? ''}
          placeholder={t(textAreaPlaceholder)}
          onChange={(e) => setMessage(e.target.value)}
          maxLength={messageMaxLength}
          data-test-id="textarea-message"
          onBlur={onblur}
        />
      </>
    ) : (
      <div className={styles.icon}>
        <Icon src={URLS.CHECKBOX_CONFIRM_CIRCLE_GREEN} alt="confirmed" />
        {message}
      </div>
    )}
  </div>
);

Message.propTypes = {
  t: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
  textAreaLabel: PropTypes.string.isRequired,
  textAreaPlaceholder: PropTypes.string,
  message: PropTypes.string,
  setMessage: PropTypes.func.isRequired,
  messageMaxLength: PropTypes.number,
  onblur: PropTypes.func
};

export default Message;
